<template>
  <component :is="view"></component>
</template>

<script>
import pageView from '~/mixins/page-view';

export default {
  name: 'DashboardRoute',
  mixins: [pageView],
  layout({ isDesktop }) {
    return `default/${isDesktop ? 'desktop' : 'mobile'}/index`;
  },
  data() {
    let component;
    // Component path needs to write explicitly so that webpack can create chunk based on explicit path
    if (this.$device.isDesktop) {
      component = import(
        /* webpackChunkName: "page-view-dashboard" */ `~/components/page-features/dashboard/desktop`
      );
    } else {
      component = import(
        /* webpackChunkName: "page-view-dashboard" */ `~/components/page-features/dashboard/mobile`
      );
    }
    return {
      component,
    };
  },
  head() {
    const header = {};
    if (this.$device.isDesktop) {
      header.meta = [
        { hid: 'viewport', name: 'viewport', content: 'width=1200' },
      ];
    }
    return header;
  },
  meta: {
    desktopBodyBackground: '#f6f6f6',
    mobileBodyBackground: '#fff',
  },
};
</script>
